import { authorizationHeader } from '@picsart/growth-rc/services/auth';

import { getContext } from '@/context';
import { CREDIT_CALCULATOR_URL } from '@/consts/urls';
import { ErrorMessages } from '@/consts/errors';
import { getAccessToken } from '@/utils/user/getAccessToken';
import { showNotification } from '@/utils/ui/showNotification';
import { NotificationType } from '@/types';

type Params = {
  webhookId: string;
};

type IResponse = {
  response: {
    result: {
      usageAmount: number;
    };
  };
  status: string;
  reason: string;
  message: string;
};

const getProjectCredits = async ({ webhookId }: Params) => {
  try {
    const response = await getContext().utils.api.fetch(CREDIT_CALCULATOR_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...authorizationHeader(getAccessToken()),
      },
      body: JSON.stringify({ params: { webhookId } }),
    });

    const data = (await response.json()) as IResponse;
    if (data?.status === 'error') {
      throw new Error(`Project credits calculation failed: ${data.message}`);
    }

    return data.response?.result?.usageAmount;
  } catch (error) {
    showNotification({
      title: ErrorMessages.presetCreditCount,
      type: NotificationType.ERROR,
    });
    return null;
  }
};

export { getProjectCredits };
